import APIs from '../../apiUrl';

const LandpageServices = {
  getPublicProducts: async ({
    name = '""',
    category = '""',
    brand = '""',
    from = 0,
    to = 0,
    limit = 10,
  }) => {
    try {
      const url = `/search_for_product_by_category/${name}/${category}/${brand}/${from}/${to}/0/${limit}`;
      const response = await APIs.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getNewProduct: async (payload) => {
    try {
      const response = await APIs.get(
        `/get_new_product/${payload.page}/${payload.limit}`
      );

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  getPublicCategories: async (payload) => {
    try {
      const response = await APIs.get(
        `/get_all_category/${payload.page}/${payload.limit}`
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default LandpageServices;
